<div class="container-fluid cards-container">
    @let kpi = kpis()[0];
    <div class="row g-3">
        <div class="col-sm-6 col-lg-3">
            <kpi-card
                [title]="texts.lvAerialBareNetworkLength.title"
                [body]="{
                    value: kpi.lvAerialBareNetworkLength,
                    suffix: texts.lvAerialBareNetworkLength.suffix,
                    precision: texts.lvAerialBareNetworkLength.precision,
                }"
                [badge]="{
                    value: kpi.lvAerialBareNetworkLengthEvolution,
                    suffix: texts.lvAerialBareNetworkLength.badgeSuffix,
                    precision: texts.lvAerialBareNetworkLength.badgePrecision,
                    style: kpi.lvAerialBareNetworkLengthEvolution! < 0 ? 'success' : 'danger',
                }"
                [descriptionTitle]="texts.lvAerialBareNetworkLength.descriptionTitle"
                [isLoading]="!kpi.organizationId"
                [error]="checkKpiErrors(kpi, 'lvAerialBareNetworkLength')"
                cardClass="h-100">
            </kpi-card>
        </div>

        <div class="col-sm-6 col-lg-3">
            <kpi-card
                [title]="texts.lvAerialBareFsNetworkLength.title"
                [body]="{
                    value: kpi.lvAerialBareFsNetworkLength,
                    suffix: texts.lvAerialBareFsNetworkLength.suffix,
                    precision: texts.lvAerialBareFsNetworkLength.precision,
                }"
                [badge]="{
                    value: kpi.lvAerialBareFsNetworkLengthEvolution,
                    suffix: texts.lvAerialBareFsNetworkLength.badgeSuffix,
                    precision: texts.lvAerialBareFsNetworkLength.badgePrecision,
                    style: kpi.lvAerialBareFsNetworkLengthEvolution! < 0 ? 'success' : 'danger',
                }"
                [descriptionTitle]="texts.lvAerialBareFsNetworkLength.descriptionTitle"
                [descriptionContent]="texts.lvAerialBareFsNetworkLength.descriptionContent"
                [isLoading]="!kpi.organizationId"
                [error]="checkKpiErrors(kpi, 'lvAerialBareFsNetworkLength')"
                cardClass="h-100">
            </kpi-card>
        </div>

        <div class="col-sm-6 col-lg-3">
            <kpi-card
                [title]="texts.lvDefaultDated1946WorksRate.title"
                [body]="{
                    value: kpi.lvDefaultDated1946WorksRate,
                    suffix: texts.lvDefaultDated1946WorksRate.suffix,
                    precision: texts.lvDefaultDated1946WorksRate.precision,
                }"
                [badge]="{
                    value: kpi.lvDefaultDated1946WorksRateEvolution,
                    suffix: texts.lvDefaultDated1946WorksRate.badgeSuffix,
                    precision: texts.lvDefaultDated1946WorksRate.badgePrecision,
                    style: kpi.lvDefaultDated1946WorksRateEvolution! < 0 ? 'success' : 'danger',
                }"
                [descriptionTitle]="texts.lvDefaultDated1946WorksRate.descriptionTitle"
                [descriptionContent]="texts.lvDefaultDated1946WorksRate.descriptionContent"
                [isLoading]="!kpi.organizationId"
                [error]="checkKpiErrors(kpi, 'lvDefaultDated1946WorksRate')"
                cardClass="h-100">
            </kpi-card>
        </div>
    </div>

    <chart-card
        id="lvNetworksAverageAge"
        [title]="texts.lvNetworksAverageAgesChart.title"
        [descriptionTitle]="texts.lvNetworksAverageAgesChart.descriptionTitle"
        [descriptionContent]="texts.lvNetworksAverageAgesChart.descriptionContent"
        [error]="averageAgesChartError"
        [isLoading]="!averageAgesChartDataSignal()[0].organizationId"
        [series]="averageAgesChartSeries"
        [dataLabels]="averageAgesChartDataLabels"
        [yaxis]="averageAgesChartYaxis"
        [precision]="texts.lvNetworksAverageAgesChart.precision"
        [grid]="averageAgesChartGrid"
        [xaxisTitle]="texts.lvNetworksAverageAgesChart.xaxisTitle"
        [unitTooltip]="texts.lvNetworksAverageAgesChart.unitTooltip"
        class="h-100">
    </chart-card>

    <div class="row g-3">
        <div class="col-sm-12 col-lg-6">
            <chart-card
                id="lvNetworksEvolOverhead"
                [title]="texts.lvNetworksEvolOverheadChart.title"
                [error]="evolLengthChartError"
                [isLoading]="!evolLengthChartDataSignal()[0].organizationId"
                [series]="evolLengthChartSeries"
                [dataLabels]="evolLengthChartDataLabels"
                [stacked]="true"
                [yaxis]="evolAgesChartYaxis"
                [plotOptions]="evolLengthPlotOptions"
                [type]="'bar'"
                [grid]="evolLengthChartGrid"
                [xaxisTitle]="texts.lvNetworksEvolOverheadChart.xaxisTitle"
                [customTooltip]="evolLengthCustomTooltip"
                [legend]="evolLengthLegend"
                class="h-100">
            </chart-card>
        </div>
        <div class="col-sm-12 col-lg-6">
            <chart-card
                id="lvNetworksEvolOverheadFs"
                [title]="texts.lvNetworksEvolOverheadFsChart.title"
                [descriptionTitle]="texts.lvNetworksEvolOverheadFsChart.descriptionTitle"
                [descriptionContent]="texts.lvNetworksEvolOverheadFsChart.descriptionContent"
                [error]="!!evolLengthFsChartDataSignal()[0].error"
                [isLoading]="evolLengthFsChartError"
                [series]="evolLengthFsChartSeries"
                [dataLabels]="evolLengthFsChartDataLabels"
                [stacked]="true"
                [yaxis]="evolAgesFsChartYaxis"
                [plotOptions]="evolLengthFsPlotOptions"
                [type]="'bar'"
                [grid]="evolLengthFsChartGrid"
                [xaxisTitle]="texts.lvNetworksEvolOverheadFsChart.xaxisTitle"
                [customTooltip]="evolLengthFsCustomTooltip"
                [legend]="evolLengthFsLegend"
                class="h-100">
            </chart-card>
        </div>
    </div>

    <chart-card
        id="lvNetworksRateComparison"
        [title]="texts.lvNetworksRateComparisonChart.title"
        [descriptionTitle]="texts.lvNetworksRateComparisonChart.descriptionTitle"
        [descriptionContent]="texts.lvNetworksRateComparisonChart.descriptionContent"
        [error]="rateComparisonChartError"
        [isLoading]="!rateComparisonChartDataSignal()[0].organizationId"
        [type]="'rangeBar'"
        [dataLabels]="rateComparisonDataLabels"
        [series]="rateComparisonChartSeries"
        [plotOptions]="rateComparisonPlotOptions"
        [customTooltip]="rateComparisonCustomTooltip"
        cardClass="h-100"></chart-card>

    <geo-map-card
        [title]="texts.lvAerialBareNetworkMap.title"
        [descriptionContent]="texts.lvAerialBareNetworkMap.descriptionContent"
        [descriptionTitle]="texts.lvAerialBareNetworkMap.descriptionTitle"
        [geometries]="geometries()"
        [isLoading]="!geometries()[0].organizationId"
        [error]="!!geometries()[0].error"
        [getStyle]="getMapStyle"
        [legendConfig]="legendConfig"
        [mapId]="'lvAerialBareNetworkMap'"
        [getTooltip]="getTooltip"></geo-map-card>
</div>
